module.exports = __webpack_public_path__ + "static/img/clock.2a9a9c24.png";